module.exports = __webpack_public_path__ + "img/icon-member_y.941ff90b.svg";